import React, { useState } from "react";
import "./style.css";
import { dentalIcons } from "../../../../../../utils-icons/dentalIcons";
import { useDispatch, useSelector } from "react-redux";
import {
  _onDeleteQuadrantObservation,
  _onDeleteToothObservation,
} from "../../../../../../../redux/actions/dentalRecordAction";

const DentalObservation = ({
  item,
  onEdit,
  onDelete,
  isDirty = false,
  type,
}) => {
  const [open, setOpen] = useState(false);
  const { metaData } = useSelector((state) => state.general);
  const dispatch = useDispatch();

  const showQuadrantFullForm = (indentifer) => {
    if (indentifer === "ur") {
      return "Upper Right (UR)";
    } else if (indentifer === "ul") {
      return "Upper Left (UL)";
    } else if (indentifer === "lr") {
      return "Lower Right (LR)";
    } else if (indentifer === "ll") {
      return "Lower Left (LL)";
    }
  };

  const showTeethISONumber = (id) => {
    const findtooth = metaData?.teeth.find((tooth) => tooth.id === id);
    if (findtooth) {
      return findtooth;
    }
  };
  return (
    <div className="dental_observation_container">
      <div className="dental_observation_body">
        <div className="dental_observation_info">
          <div className="dental_observation_info_detail">
            <p>
              {type === "quadrant"
                ? showQuadrantFullForm(item.identifier)
                : showTeethISONumber(item.id)?.name}
            </p>
            <span>
              {type === "quadrant"
                ? item.identifier
                : showTeethISONumber(item.id)?.iso}
            </span>
          </div>
          <div onClick={() => setOpen(!open)}>
            <img src={open ? dentalIcons.arrowUp : dentalIcons.arrowDown} />
          </div>
        </div>
        {open && (
          <>
            <div className="dental_observation_collapse">
              <p>{item.observation}</p>
            </div>
            {isDirty && (
              <div className="dental_observation_collapse_actions">
                <img src={dentalIcons.caseDetailIcon} onClick={onEdit} />
                <img
                  src={dentalIcons.caseDeleteIcon}
                  onClick={() =>
                    type === "quadrant"
                      ? dispatch(_onDeleteQuadrantObservation(item.identifier))
                      : dispatch(_onDeleteToothObservation(item.id))
                  }
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default DentalObservation;
